import { render } from "./UndergroundNpc2.vue?vue&type=template&id=001b100b&scoped=true"
import script from "./UndergroundNpc2.vue?vue&type=script&lang=js"
export * from "./UndergroundNpc2.vue?vue&type=script&lang=js"

import "./UndergroundNpc2.vue?vue&type=style&index=0&id=001b100b&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001b100b"]])

export default __exports__